import { ACCESS_TOKEN } from "requests/constants";

export function downloadWithFileName(file_path: string, fileName: string) {
  fetch(file_path, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
    }),
  })
    .then((response) => response.blob())
    .then((blob) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}


export async function downloadWithFileNameAsync(
  file_path: string,
  fileName: string
): Promise<void> {
  const response = await fetch(file_path, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
      tenant: localStorage.getItem("currentTenant") || "",
    }),
  });

  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;

  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
}

export function download(file_path: string) {
  fetch(file_path, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
    }),
  })
    .then((response) => response.blob())
    .then((blob) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = file_path.substr(file_path.lastIndexOf("/") + 1);
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}
